"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveOrganizationId = getActiveOrganizationId;
exports.isExchangeAdminOfOrganization = isExchangeAdminOfOrganization;
exports.isManaged = void 0;
function isExchangeAdminOfOrganization(profile, organization) {
  var organizationFromProfile = profile && profile.contributorOfOrganizations.find(function (_ref) {
    var id = _ref.id;
    return id === organization.id;
  });
  return organizationFromProfile ? organizationFromProfile.isExchangeAdmin : false;
}
function getActiveOrganizationId(profile) {
  if (profile) {
    return profile.properties && profile.properties.cs_auth ? profile.properties.cs_auth.activeOrganizationId : profile.organization.id;
  }
  return null;
}
var isManaged = exports.isManaged = function isManaged(_ref2) {
  var type = _ref2.type;
  return type === 'managed';
};
//# sourceMappingURL=utils.js.map